import { useCallback, useRef, useState } from 'react';
/** Controlled when `value` is defined, otherwise internal state seeded from `defaultValue`. */
export function useControllable(value, defaultValue, onChange) {
    const [inner, setInner] = useState(defaultValue);
    const controlled = value !== undefined;
    const current = controlled ? value : inner;
    const latest = useRef(current);
    latest.current = current;
    const set = useCallback((next) => {
        if (Object.is(next, latest.current))
            return;
        if (!controlled)
            setInner(next);
        onChange?.(next);
    }, [controlled, onChange]);
    return [current, set];
}
/** The hidden-series list behind legend toggles, controlled or uncontrolled. */
export function useHiddenSeries(hidden, defaultHidden = [], onChange) {
    const [current, set] = useControllable(hidden, defaultHidden, onChange);
    const toggle = useCallback((key) => set(current.includes(key) ? current.filter((k) => k !== key) : [...current, key]), [current, set]);
    return [current, toggle];
}
//# sourceMappingURL=use-controllable.js.map